import { render, staticRenderFns } from "./ElementWeightWithDisableTableColumn.vue?vue&type=template&id=63d44dac"
import script from "./ElementWeightWithDisableTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementWeightWithDisableTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports